import Axios from "axios";
import {
    SET_BUDGET_SUB_HEAD_LIST,
    UNSET_BUDGET_SUB_HEAD_LIST,
} from "@/store/mutation-types";
import { 
    budgetSubHeadResource,
} from "@/store/api";

const state = {
    getBudgetSubHeadList: [],
};

const getters = {
    getBudgetSubHeadList(state) {
        return state.getBudgetSubHeadList;
    },
};

const mutations = {
    [SET_BUDGET_SUB_HEAD_LIST](state, data) {
        state.getBudgetSubHeadList = data;
    },
    [UNSET_BUDGET_SUB_HEAD_LIST](state) {
        state.getBudgetSubHeadList = [];
    },
};

const actions = {
    saveBudgetSubHead({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(budgetSubHeadResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBudgetSubHead({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${budgetSubHeadResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBudgetSubHeadList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(budgetSubHeadResource)
            .then(function (response) {
            commit('SET_BUDGET_SUB_HEAD_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BUDGET_SUB_HEAD_LIST');
            reject(error);
            });
        });
    },

    getBudgetSubHeadById({ commit }, data) {
        const getBudgetSubHeadRecordById = `${budgetSubHeadResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBudgetSubHeadRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

